import GetInitialHoklaRequestRequestModelBase from '../_generated/modelBases/get-initial-hokla-request-request-model-base';

export default class GetInitialHoklaRequestRequestModel extends GetInitialHoklaRequestRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
